import React, { useEffect } from "react"
import browserLang from "browser-lang"
import { PluginOptions, WrapPageElementNodeArgs } from "gatsby"
import { SitePageContext } from "gatsby-plugin-i18n-l10n/types"
import { navigate } from 'gatsby'
import { getLocaleFromStore } from "./utils/localeStorage"

export const wrapPageElement = (
    args: WrapPageElementNodeArgs<Record<string, unknown>, SitePageContext> & { loadPage: (path: string) => any },
    options: PluginOptions,
  ) => {
    console.log(args);
    console.log(options);

    const currentLocale = args.props.pageContext.locale;

    useEffect(() => {
        const preferredLocale = browserLang({ languages: [args.props.pageContext.locale!, ...args.props.pageContext.translations!.map(t => t.locale)], fallback: "en" });

        const localeFromStore = getLocaleFromStore();

        if (localeFromStore) {
            if (localeFromStore == currentLocale) {
                return;
            }

            const translation = args.props.pageContext.translations?.find(t => t.locale === localeFromStore);

            if (translation) {
                navigate(translation.path);

                return;
            }
            
        }

        if (preferredLocale !== currentLocale && !localeFromStore) {
            navigate(args.props.pageContext.translations!.find(t => t.locale === preferredLocale)!.path);
        }

    }, []);

    return args.element;
}